
































































































































































































































































































































































import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import {number} from '@coders-tm/vue-number-format';
import _ from 'lodash';
import { Tariff, UserPreset, UniversalData } from "@/services/models-service";
import { tariffWarmEnergy, tariffWarmPower} from "@/constants";
import DxContextMenu from 'devextreme-vue/context-menu';
import { periods } from "@/constants";
import DNumberbox from "@/components/DNumberbox/numberbox.vue";
import choicePopup from "@/components/InputComponents/choice-popup.vue";
import {alert} from 'devextreme/ui/dialog';
import { confirm } from "devextreme/ui/dialog";

@Component({
  name: 'RowInputs',
  components: {
    number,
    DxContextMenu,
    DNumberbox,
    choicePopup
  }
})
export default class  extends Vue {
  @PropSync('presets') public localPresets!: UserPreset;
  @PropSync('portion') public saleData!: any;
  @PropSync('data') public dataList!: any;
  @PropSync('secondaryPortion') public secondaryBlock!: any;
  @PropSync('removeList') public removeDataList!: UniversalData[];
  @Prop() public periodName!: string;
  @Prop() public blockId!: string;
  @Prop() public tariffs!: { [key: string]:  any; };
  @Prop() public secondaryTariffs!: { [key: string]:  any; };
  @Prop() public blockAccept!: any;
  @Prop({default: false}) public editingVolume!: boolean;
  @Prop({default: false}) public editingRows!: boolean;
  @Prop({default: false}) public strictTariffCalc!: boolean;

  public options: any[] = [];
  public months = periods;

  public tariffWarmEnergy: any = tariffWarmEnergy;
  public tariffWarmPower: any = tariffWarmPower;

  public initiated: boolean = false;
  public isRowMoving: boolean = false;

  public choicePopup: any = {
    visible: false,
    te: false,
    power: false,
    tariff: 1,
    volume: false,
    cost: false,
    block: ''
  }

  public currentData: UniversalData | null = null;

  get tarifReadOnly() {
    if(this.blockAccept && this.blockAccept.tarif) {
      return true;
    } else {
      return false;
    }
  }

  get volumeReadOnly() {
    if(this.blockAccept && this.blockAccept.volume) {
      return true;
    } else {
      return false;
    }
  }

  get costReadOnly() {
    if (this.strictTariffCalc) return true;
    if(this.volumeReadOnly && this.tarifReadOnly) {
      return true;
    } else {
      return false;
    }
  }

  async mounted() {
    this.options = [
        { text: 'Удалить' },
      ];
    this.initiated = true;
    this.choicePopup.block = this.blockId;
    
    this.$root.$on('row-moving-start', () => {
      this.isRowMoving = true;
    });
    this.$root.$on('row-moving-end', () => {
      this.isRowMoving = false;
    });
  }
  
  beforeDestroy() {
    this.$root.$off('row-moving-start');
    this.$root.$off('row-moving-end');
  }

  itemClick(e: any, data: any) {
    if (e.itemData.text === "Удалить") {
      if(data.vol_te || data.vol_power || data.cost_te || data.cost_power) {
        confirm('Удалить существующие данные', 'Подтверждение удаления')
        .then((answer: boolean) => {
          if (!answer) {
            return
          }
          this.removeRowData(data);
        })
      } else {
        this.removeRowData(data);
      }
    }
  }

  removeRowData(data: any) {
    let index = this.saleData.indexOf(data);
    for(let i = 0; i < this.months.length; i++) {
      if (this.dataList[this.months[i]][index].id) {
        delete this.dataList[this.months[i]][index].isFocused;
        this.removeDataList.push(this.dataList[this.months[i]][index]);
      }
      this.dataList[this.months[i]].splice(index, 1);
    }
  }

  changeVolPower(data: UniversalData) {
    data.vol_power = this.checkNumber(data.vol_power)
    const tarif = this.tariffs[data.id_tarif];
    if (this.strictTariffCalc) {
      data.cost_power = data.vol_power * tarif[this.tariffWarmPower[this.periodName]] / 1000;
      data.cost_delta_power = 0;
      data.cost_total = data.cost_te + data.cost_power;
      return;
    }
    if (data.cost_power === 0) {
      data.cost_power = data.vol_power * tarif[this.tariffWarmPower[this.periodName]] / 1000;
      data.cost_delta_power = 0;
      data.cost_total = data.cost_te + data.cost_power;
    } else {
      this.currentData = data;
      this.choicePopup.tariff = tarif[this.tariffWarmPower[this.periodName]];
      this.choicePopup.power = true;
      this.choicePopup.volume = true;
      this.choicePopup.visible = true;
    }
  }

  changeCostPower(data: any) {
    data.cost_power = this.checkNumber(data.cost_power)
    const tarif = this.tariffs[data.id_tarif];
    if (this.strictTariffCalc) {
      data.cost_power = data.vol_power * tarif[this.tariffWarmPower[this.periodName]] / 1000;
      data.cost_total = data.cost_te + data.cost_power;
      return;
    }
    if (this.volumeReadOnly && !this.isRowMoving) {
      alert('Нельзя менять стоимость при акцептированном объёме', 'Ошибка');
      data.cost_power = tarif[this.tariffWarmPower[this.periodName]] * data.vol_power / 1000;
      data.cost_total = data.cost_te + data.cost_power;
    } else {
      if (tarif[this.tariffWarmPower[this.periodName]] < 0 || tarif[this.tariffWarmPower[this.periodName]] === 0) {
        data.cost_power = 0;
        data.cost_total = data.cost_te + data.cost_power;
      } else {
        this.currentData = data;
        this.choicePopup.tariff = tarif[this.tariffWarmPower[this.periodName]];
        this.choicePopup.power = true;
        this.choicePopup.cost = true;
        this.choicePopup.visible = true;
      }
    }
  }

  changeVolTe(data: UniversalData) {
    data.vol_te = this.checkNumber(data.vol_te)
    const tarif = this.tariffs[data.id_tarif];
    if (this.strictTariffCalc) {
      data.cost_te = data.vol_te * tarif[this.tariffWarmEnergy[this.periodName]];
      data.cost_delta_te = 0;
      if (tarif.two_part) {
        data.cost_power = data.vol_power * tarif[this.tariffWarmPower[this.periodName]] / 1000;
        data.cost_delta_power = 0;
      } else {
        data.vol_power = data.cost_power = data.cost_delta_power = 0;
      }
      data.cost_total = data.cost_te + data.cost_power;
      return;
    }
    if (data.cost_te === 0) {
      data.cost_te = data.vol_te * tarif[this.tariffWarmEnergy[this.periodName]];
      data.cost_delta_te = 0;
      data.cost_total = data.cost_te + data.cost_power;
    } else {
      this.currentData = data;
      this.choicePopup.tariff = tarif[this.tariffWarmEnergy[this.periodName]];
      this.choicePopup.te = true;
      this.choicePopup.volume = true;
      this.choicePopup.visible = true;
    }
  }

  changeCostTe(data: UniversalData) {
    data.cost_te = this.checkNumber(data.cost_te)
    const tarif = this.tariffs[data.id_tarif];
    if (this.strictTariffCalc) {
      data.cost_te = data.vol_te * tarif[this.tariffWarmEnergy[this.periodName]];
      data.cost_total = data.cost_te + data.cost_power;
      return;
    }
    if (this.volumeReadOnly && !this.isRowMoving) {
      alert('Нельзя менять стоимость при акцептированном объёме', 'Ошибка');
      data.cost_te = tarif[this.tariffWarmEnergy[this.periodName]] * data.vol_te;
      data.cost_total = data.cost_te + data.cost_power;
    } else {
      if (tarif[this.tariffWarmEnergy[this.periodName]] < 0 || tarif[this.tariffWarmEnergy[this.periodName]] === 0) {
        data.cost_te = 0;
        data.cost_total = data.cost_te + data.cost_power;
      } else {
        this.currentData = data;
        this.choicePopup.tariff = tarif[this.tariffWarmEnergy[this.periodName]];
        this.choicePopup.te = true;
        this.choicePopup.cost = true;
        this.choicePopup.visible = true;
      }
    }
  }



  focusInNumberBox(data: any, e: any) {
    data.isFocused = true;
    this.saleData = [ ...this.saleData ];
    let inputEl = e.element.querySelector(".dx-texteditor-input");
    Vue.nextTick(() => {
      inputEl.selectionStart = 0;
      inputEl.selectionEnd = inputEl.value.length;
    })
  }

  focusOutNumberBox(data:any) {
    data.isFocused = false;
    this.saleData = [ ...this.saleData ];
  }

  correctFormat(e:any) {
    let inputEl = e.element.querySelector(".dx-texteditor-input");
    inputEl.addEventListener('paste', (event:any) => {
      event.preventDefault();
      let paste = (event.clipboardData || (window as any).clipboardData).getData('text');
      paste = paste.replace(".", ",");
      inputEl.value = paste;
    })
  }

  checkNumber(value: any) {
    console.log(value)
    if (value instanceof Number) {
      value = value.valueOf();
    }
    if(isFinite(value) && value === parseInt(value, 10)) {
      return value
    } else {
      return 0
    }
  }

  get route() {
    return this.$route.name
  }

  get show_volume() {
    if((this.localPresets.losses_show_volume && this.route === 'losses')  || (this.localPresets.buy_show_volume && this.route === 'buy') ||
    (this.localPresets.sale_show_volume && this.route === 'sale') || (this.localPresets.transport_cost_show_volume && this.route === 'transport_cost') ||
    (this.localPresets.transport_gain_show_volume && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost() {
    if((this.localPresets.buy_show_cost && this.route === 'buy') || (this.localPresets.sale_show_cost && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost_delta() {
    if((this.localPresets.buy_show_cost_delta && this.route === 'buy') || (this.localPresets.sale_show_cost_delta && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost_delta && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost_delta && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost_total() {
    if((this.localPresets.buy_show_cost_total && this.route === 'buy') || (this.localPresets.sale_show_cost_total && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost_total && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost_total && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_price() {
    if((this.localPresets.buy_show_price && this.route === 'buy') || (this.localPresets.sale_show_price && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_price && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_price && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_price_total() {
    if((this.localPresets.buy_show_price_total && this.route === 'buy') || (this.localPresets.sale_show_price_total && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_price_total && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_price_total && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  // Отключаю всплывающее окно пересчёта стоимости при strictTariffCalc
  get showChoicePopup() {
    return !this.strictTariffCalc && this.currentData;
  }

}
